<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-account"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ $t('debtors') }}
            </div>
          </v-col>
        </template>
        <div>
            <v-simple-table>
              <template v-slot:default>
                  <tr
                    v-for="(item, index) in debtors"
                    :key="item.id"
                  >
                    <td style="width: 30%;">
                        <v-select
                            v-model="debtors[index].currency_code"
                            :label="$t('currency')"
                            :items="currencies"
                            item-text="label"
                            item-value="value"
                        />
                    </td>
                    <td style="width: 30%">
                      <v-select
                            v-model="debtors[index].company_id"
                            :label="$t('company')"
                            :items="companies"
                            item-text="label"
                            item-value="value"
                        />
                    </td>
                    <td style="width: 40%">
                        <v-text-field
                            v-model="debtors[index].number"
                            :label="$t('debtor_number')"
                        >
                        </v-text-field>
                    </td>
                    <td style="">
                      <v-btn
                        small
                        color="red"
                        @click="removeDebtor(index)"
                      >
                        {{ $t('delete') }}
                      </v-btn>
                    </td>
                  </tr>
              </template>
            </v-simple-table>
            <div style="width: 100%;">
            <v-btn
                 style="float: right; margin-left: 40px"
                small
                color="grey"
                @click="addDebtor()"
                >
                +
            </v-btn>
            <v-btn
                color="green"
                @click="updateDebtors()"
                >
                {{ $t('update') }}
            </v-btn>
            </div>
        </div>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
  import Auth from '../../../../mixins/Auth'
  import _ from 'lodash'
  import moment from 'moment'
  export default {

    mixins: [Auth],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        name: 'debtors',
        debtors: [],
        companies: [],
        currencies: []
      }
    },
    computed: {},
    mounted: function () {
      this.getDataFromApi()
    },
    methods: {
      getDataFromApi: function () {
        this.$get(`/debtors/${this.$route.params.id}`)
          .then(res => {
            this.debtors = res.data.debtors
            console.log(this.debtors);
          }),
          this.$get(`/debtors/describe`)
          .then(res => {
            this.companies = res.data.companies
            this.currencies = res.data.currencies
            console.log(this.companies, this.currencies);
          })
      },
      removeDebtor: function (index) {
        this.debtors.splice(index, 1)
        this.updateDebtors()
      },
      addDebtor: function() {
        let debtor = {
          company_id: 1,
          currency_code: "DKK",
          number: "",
        }
        this.debtors.push(debtor)
      },
      updateDebtors: function () {
        this.$put(`/debtors/${this.$route.params.id}`, { debtors: this.debtors } )
          .then(response => {
            this.$toast(`${this.$t('debtors')} ${this.$t('saved_correctly')}`)
          })
      },
    }
  }
</script>
